import { Autocomplete, TextField } from "@mui/material"
import CustomInput from "Shared/CustomInput"
import CustomNewInput from "Shared/CustomNewInput"
import { toast } from "react-toastify"

const SearchAndSelect = ({
    options,
    label,
    formik,
    name,
    setValue,
    onChange = () => { },
    value,
    isRequired = false,
    className = "",
    loading = false,
    setChanges,
    placeholder = "Search and Select ",
}) => {
    const handleChange = (_event, newValue) => {
        const selectedValue = newValue ? newValue.value : null
        if (formik) {
            formik.setFieldValue(name, selectedValue)
        } else {
            setValue ? setValue(selectedValue) : toast.info("Provide setValue Function")
        }
        onChange(_event, newValue)
    }
    // const handleInputChange = (_event, newInputValue) => {
    //   if (setChanges) {
    //     setChanges(newInputValue)
    //   }
    // }
    let selectedOption

    if (formik) {
        selectedOption = options && options.find((option) => option.value === (formik ? formik.values?.[name] : value));

    } else {
        selectedOption = options && options.find((option) => option.value === value)
    }

    return (
        <Autocomplete
            options={options || []}
            loading={loading}
            value={selectedOption || null}
            onChange={handleChange}
            // onInputChange={handleInputChange}
            getOptionLabel={(option) => option.label}
            clearOnEscape
            size="small"
            renderInput={(params) => (



                <CustomNewInput
                    id={name}
                    isRequired={isRequired}
                    {...params}
                    label={label}
                    onChange={(e) => setChanges(e.target.value)}
                    placeholder={label ? placeholder + label : placeholder}
                    className={className}

                />
            )}
        />
    )
}

export default SearchAndSelect
